export const vkLogin = 'vkLogin'
export const instLogin = 'instLogin'
export const okLogin = 'okLogin'
export const paymentAgree = 'paymentAgree'
export const instDelayedLogin = 'instDelayedLogin'
export const accessToken = 'accessToken'
export const finishProjectData = 'finishProjectData'